import type { TipsInfo } from '../schema';
import { getOwaResourceImageUrl } from 'owa-resource-url';
import {
    tipsButtonShowMeHow,
    tipsButtonSeeShortcutKeys,
    tipsInstructionsAddWidget,
    tipsInstructionsShortcutKeys,
    tipsInstructionsFilePin,
    tipsButtonShowMeHowAriaLabel,
    tipsButtonSeeShortcutKeysAriaLabel,
} from '../tipStrings.locstring.json';
import getThemeType from './getThemeType';
import { showTeachingMoment, TeachingMomentId } from 'owa-timestream-asset-sdk-actions';

export default function getTipsInfo(): TipsInfo[] {
    return [
        {
            imagePath: buildImagePath('Tips_1'),
            instructionsResourceId: tipsInstructionsAddWidget,
            buttonTextResourceId: tipsButtonShowMeHow,
            teaching: () => showTeachingMoment(TeachingMomentId.AddWidget),
            showImageBackground: false,
            ariaLabelResourceId: tipsButtonShowMeHowAriaLabel,
        },
        {
            imagePath: buildImagePath('Tips_3'),
            instructionsResourceId: tipsInstructionsShortcutKeys,
            buttonTextResourceId: tipsButtonSeeShortcutKeys,
            teaching: () => showTeachingMoment(TeachingMomentId.ShortcutKeys),
            showImageBackground: false,
            ariaLabelResourceId: tipsButtonSeeShortcutKeysAriaLabel,
        },
        {
            imagePath: buildImagePath('Tips_5'),
            instructionsResourceId: tipsInstructionsFilePin,
            buttonTextResourceId: tipsButtonShowMeHow,
            teaching: () => showTeachingMoment(TeachingMomentId.PinFile),
            showImageBackground: true,
            ariaLabelResourceId: tipsButtonShowMeHowAriaLabel,
        },
    ];
}

function buildImagePath(imageName: string): string {
    return getOwaResourceImageUrl(`${imageName}_${getThemeType()}.svg`);
}
